export default [
    {
        logoId: 1,
        name: "Proficiência com Escudo",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 18,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 26 de dano físico e atordoa por 3 segundos.",
                necessaryLevel: 1,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 22,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 32 de dano físico e atordoa por 3 segundos.",
                necessaryLevel: 4,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 31,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 44 de dano físico e atordoa por 3 segundos.",
                necessaryLevel: 8,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 39,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 56 de dano físico e atordoa por 3 segundos.",
                necessaryLevel: 12,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 48,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 69 de dano físico e atordoa por 3 segundos.",
                necessaryLevel: 16,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 60,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 86 de dano físico e atordoa por 3 segundos.",
                necessaryLevel: 20,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 73,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 104 de dano físico e atordoa por 3 segundos.",
                necessaryLevel: 24,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 88,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 126 de dano físico e atordoa por 3 segundos.",
                necessaryLevel: 28,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 107,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 153 de dano físico e atordoa por 4 segundos.",
                necessaryLevel: 32,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 130,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 185 de dano físico e atordoa por 4 segundos.",
                necessaryLevel: 36,
            },
            {
                level: 11,
                cooldown: 12,
                mp: 157,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 224 de dano físico e atordoa por 4 segundos.",
                necessaryLevel: 40,
            },
            {
                level: 12,
                cooldown: 12,
                mp: 184,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 263 de dano físico e atordoa por 4 segundos.",
                necessaryLevel: 44,
            },
            {
                level: 13,
                cooldown: 12,
                mp: 218,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 311 de dano físico e atordoa por 4 segundos.",
                necessaryLevel: 48,
            },
            {
                level: 14,
                cooldown: 12,
                mp: 252,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 360 de dano físico e atordoa por 4 segundos.",
                necessaryLevel: 52,
            },
            {
                level: 15,
                cooldown: 12,
                mp: 292,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 417 de dano físico e atordoa por 4 segundos.",
                necessaryLevel: 56,
            },
            {
                level: 16,
                cooldown: 12,
                mp: 336,
                cast: 0,
                info:
                    "Ataca o inimigo com o escudo causando 480 de dano físico e atordoa por 4 segundos.",
                necessaryLevel: 60,
            },
        ],
    },
    {
        logoId: 2,
        name: "Remediar",
        levelsInfo: [
            {
                level: 1,
                cooldown: 4,
                mp: 106,
                cast: 0,
                info:
                    "Regenera 233 de HP do usuário ou um aliado e cura HP extra equivalente a 6% do HP perdido.",
                necessaryLevel: 4,
            },
            {
                level: 2,
                cooldown: 4,
                mp: 141,
                cast: 0,
                info:
                    "Regenera 310 de HP do usuário ou um aliado e cura HP extra equivalente a 6% do HP perdido.",
                necessaryLevel: 8,
            },
            {
                level: 3,
                cooldown: 4,
                mp: 177,
                cast: 0,
                info:
                    "Regenera 388 de HP do usuário ou um aliado e cura HP extra equivalente a 6% do HP perdido.",
                necessaryLevel: 12,
            },
            {
                level: 4,
                cooldown: 4,
                mp: 216,
                cast: 0,
                info:
                    "Regenera 475 de HP do usuário ou um aliado e cura HP extra equivalente a 6% do HP perdido.",
                necessaryLevel: 16,
            },
            {
                level: 5,
                cooldown: 4,
                mp: 267,
                cast: 0,
                info:
                    "Regenera 587 de HP do usuário ou um aliado e cura HP extra equivalente a 7% do HP perdido.",
                necessaryLevel: 20,
            },
            {
                level: 6,
                cooldown: 4,
                mp: 319,
                cast: 0,
                info:
                    "Regenera 700 de HP do usuário ou um aliado e cura HP extra equivalente a 7% do HP perdido.",
                necessaryLevel: 24,
            },
            {
                level: 7,
                cooldown: 4,
                mp: 384,
                cast: 0,
                info:
                    "Regenera 843 de HP do usuário ou um aliado e cura HP extra equivalente a 7% do HP perdido.",
                necessaryLevel: 28,
            },
            {
                level: 8,
                cooldown: 4,
                mp: 460,
                cast: 0,
                info:
                    "Regenera 1010 de HP do usuário ou um aliado e cura HP extra equivalente a 7% do HP perdido.",
                necessaryLevel: 32,
            },
            {
                level: 9,
                cooldown: 4,
                mp: 551,
                cast: 0,
                info:
                    "Regenera 1210 de HP do usuário ou um aliado e cura HP extra equivalente a 8% do HP perdido.",
                necessaryLevel: 36,
            },
            {
                level: 10,
                cooldown: 4,
                mp: 659,
                cast: 0,
                info:
                    "Regenera 1448 de HP do usuário ou um aliado e cura HP extra equivalente a 8% do HP perdido.",
                necessaryLevel: 40,
            },
            {
                level: 11,
                cooldown: 4,
                mp: 769,
                cast: 0,
                info:
                    "Regenera 1690 de HP do usuário ou um aliado e cura HP extra equivalente a 8% do HP perdido.",
                necessaryLevel: 44,
            },
            {
                level: 12,
                cooldown: 4,
                mp: 898,
                cast: 0,
                info:
                    "Regenera 1973 de HP do usuário ou um aliado e cura HP extra equivalente a 8% do HP perdido.",
                necessaryLevel: 48,
            },
            {
                level: 13,
                cooldown: 4,
                mp: 1032,
                cast: 0,
                info:
                    "Regenera 2268 de HP do usuário ou um aliado e cura HP extra equivalente a 9% do HP perdido.",
                necessaryLevel: 52,
            },
            {
                level: 14,
                cooldown: 4,
                mp: 1182,
                cast: 0,
                info:
                    "Regenera 2598 de HP do usuário ou um aliado e cura HP extra equivalente a 9% do HP perdido.",
                necessaryLevel: 56,
            },
            {
                level: 15,
                cooldown: 4,
                mp: 1334,
                cast: 0,
                info:
                    "Regenera 2933 de HP do usuário ou um aliado e cura HP extra equivalente a 9% do HP perdido.",
                necessaryLevel: 60,
            },
            {
                level: 16,
                cooldown: 4,
                mp: 1497,
                cast: 0,
                info:
                    "Regenera 3290 de HP do usuário ou um aliado e cura HP extra equivalente a 9% do HP perdido.",
                necessaryLevel: 64,
            },
        ],
    },
    {
        logoId: 3,
        name: "Nêmesis",
        levelsInfo: [
            {
                level: 1,
                cooldown: 3,
                mp: 48,
                cast: 1,
                info:
                    "Causa 80 de dano físico e reduz a velocidade em 15 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 6,
            },
            {
                level: 2,
                cooldown: 3,
                mp: 61,
                cast: 1,
                info:
                    "Causa 102 de dano físico e reduz a velocidade em 16 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 10,
            },
            {
                level: 3,
                cooldown: 3,
                mp: 79,
                cast: 1,
                info:
                    "Causa 131 de dano físico e reduz a velocidade em 17 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 14,
            },
            {
                level: 4,
                cooldown: 3,
                mp: 97,
                cast: 1,
                info:
                    "Causa 162 de dano físico e reduz a velocidade em 18 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 18,
            },
            {
                level: 5,
                cooldown: 3,
                mp: 121,
                cast: 1,
                info:
                    "Causa 201 de dano físico e reduz a velocidade em 19 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 22,
            },
            {
                level: 6,
                cooldown: 3,
                mp: 145,
                cast: 1,
                info:
                    "Causa 242 de dano físico e reduz a velocidade em 20 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 26,
            },
            {
                level: 7,
                cooldown: 3,
                mp: 176,
                cast: 1,
                info:
                    "Causa 293 de dano físico e reduz a velocidade em 21 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 30,
            },
            {
                level: 8,
                cooldown: 3,
                mp: 214,
                cast: 1,
                info:
                    "Causa 357 de dano físico e reduz a velocidade em 22 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 34,
            },
            {
                level: 9,
                cooldown: 3,
                mp: 258,
                cast: 1,
                info:
                    "Causa 430 de dano físico e reduz a velocidade em 23 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 38,
            },
            {
                level: 10,
                cooldown: 3,
                mp: 308,
                cast: 1,
                info:
                    "Causa 513 de dano físico e reduz a velocidade em 24 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 42,
            },
            {
                level: 11,
                cooldown: 3,
                mp: 363,
                cast: 1,
                info:
                    "Causa 605 de dano físico e reduz a velocidade em 25 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 46,
            },
            {
                level: 12,
                cooldown: 3,
                mp: 428,
                cast: 1,
                info:
                    "Causa 714 de dano físico e reduz a velocidade em 26 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 50,
            },
            {
                level: 13,
                cooldown: 3,
                mp: 495,
                cast: 1,
                info:
                    "Causa 825 de dano físico e reduz a velocidade em 27 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 54,
            },
            {
                level: 14,
                cooldown: 3,
                mp: 571,
                cast: 1,
                info:
                    "Causa 952 de dano físico e reduz a velocidade em 28 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 58,
            },
            {
                level: 15,
                cooldown: 3,
                mp: 650,
                cast: 1,
                info:
                    "Causa 1083 de dano físico e reduz a velocidade em 29 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 62,
            },
            {
                level: 16,
                cooldown: 3,
                mp: 730,
                cast: 1,
                info:
                    "Causa 1217 de dano físico e reduz a velocidade em 30 por 5 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 66,
            },
        ],
    },
    {
        logoId: 4,
        name: "Incitar Multidão",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 32,
                cast: 0,
                info:
                    "Aumenta 1 nível da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 8,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 38,
                cast: 0,
                info:
                    "Aumenta 2 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 12,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 44,
                cast: 0,
                info:
                    "Aumenta 3 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 16,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 52,
                cast: 0,
                info:
                    "Aumenta 4 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 20,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 60,
                cast: 0,
                info:
                    "Aumenta 5 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 24,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 71,
                cast: 0,
                info:
                    "Aumenta 6 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 28,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 83,
                cast: 0,
                info:
                    "Aumenta 7 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 32,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 97,
                cast: 0,
                info:
                    "Aumenta 8 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 36,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 114,
                cast: 0,
                info:
                    "Aumenta 9 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 40,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 132,
                cast: 0,
                info:
                    "Aumenta 10 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 44,
            },
            {
                level: 11,
                cooldown: 12,
                mp: 152,
                cast: 0,
                info:
                    "Aumenta 11 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 48,
            },
            {
                level: 12,
                cooldown: 12,
                mp: 173,
                cast: 0,
                info:
                    "Aumenta 12 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 52,
            },
            {
                level: 13,
                cooldown: 12,
                mp: 197,
                cast: 0,
                info:
                    "Aumenta 13 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 56,
            },
            {
                level: 14,
                cooldown: 12,
                mp: 223,
                cast: 0,
                info:
                    "Aumenta 14 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 60,
            },
            {
                level: 15,
                cooldown: 12,
                mp: 247,
                cast: 0,
                info:
                    "Aumenta 15 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 64,
            },
            {
                level: 16,
                cooldown: 12,
                mp: 273,
                cast: 0,
                info:
                    "Aumenta 16 níveis da taxa de perigo em todos os inimigos dentro de uma área de 4M.",
                necessaryLevel: 68,
            },
        ],
    },
    {
        logoId: 5,
        name: "Guardião",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 75,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 20%, porém perde-se 5 de esquiva.",
                necessaryLevel: 10,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 93,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 21%, porém perde-se 5 de esquiva.",
                necessaryLevel: 14,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 114,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 22%, porém perde-se 5 de esquiva.",
                necessaryLevel: 18,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 139,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 23%, porém perde-se 6 de esquiva.",
                necessaryLevel: 22,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 166,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 24%, porém perde-se 6 de esquiva.",
                necessaryLevel: 26,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 199,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 25%, porém perde-se 6 de esquiva.",
                necessaryLevel: 30,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 239,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 26%, porém perde-se 7 de esquiva.",
                necessaryLevel: 34,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 286,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 27%, porém perde-se 7 de esquiva.",
                necessaryLevel: 38,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 337,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 28%, porém perde-se 7 de esquiva.",
                necessaryLevel: 42,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 394,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 29%, porém perde-se 8 de esquiva.",
                necessaryLevel: 46,
            },
            {
                level: 11,
                cooldown: 6,
                mp: 458,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 30%, porém perde-se 8 de esquiva.",
                necessaryLevel: 50,
            },
            {
                level: 12,
                cooldown: 6,
                mp: 524,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 31%, porém perde-se 8 de esquiva.",
                necessaryLevel: 54,
            },
            {
                level: 13,
                cooldown: 6,
                mp: 601,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 32%, porém perde-se 9 de esquiva.",
                necessaryLevel: 58,
            },
            {
                level: 14,
                cooldown: 6,
                mp: 674,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 33%, porém perde-se 9 de esquiva.",
                necessaryLevel: 62,
            },
            {
                level: 15,
                cooldown: 6,
                mp: 750,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 34%, porém perde-se 9 de esquiva.",
                necessaryLevel: 66,
            },
            {
                level: 16,
                cooldown: 6,
                mp: 833,
                cast: 3,
                info:
                    "Durante 10 minutos, danos de demônios e mortos-vivos são reduzidos em 35%, porém perde-se 10 de esquiva.",
                necessaryLevel: 70,
            },
        ],
    },
    {
        logoId: 6,
        name: "Sangue Sagrado",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 56,
                cast: 0,
                info:
                    "Durante 20 segundos retorna 50% do dano aplicado em inimigo em seu HP.",
                necessaryLevel: 12,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 68,
                cast: 0,
                info:
                    "Durante 22 segundos retorna 55% do dano aplicado em inimigo em seu HP.",
                necessaryLevel: 16,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 84,
                cast: 0,
                info:
                    "Durante 24 segundos retorna 60% do dano aplicado em inimigo em seu HP.",
                necessaryLevel: 20,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 101,
                cast: 0,
                info:
                    "Durante 26 segundos retorna 65% do dano aplicado em inimigo em seu HP.",
                necessaryLevel: 24,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 121,
                cast: 0,
                info:
                    "Durante 28 segundos retorna 70% do dano aplicado em inimigo em seu HP.",
                necessaryLevel: 28,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 146,
                cast: 0,
                info:
                    "Durante 30 segundos retorna 75% do dano aplicado em inimigo em seu HP.",
                necessaryLevel: 32,
            },
            {
                level: 7,
                cooldown: 120,
                mp: 174,
                cast: 0,
                info:
                    "Durante 32 segundos retorna 80% do dano aplicado em inimigo em seu HP.",
                necessaryLevel: 36,
            },
            {
                level: 8,
                cooldown: 120,
                mp: 208,
                cast: 0,
                info:
                    "Durante 34 segundos retorna 85% do dano aplicado em inimigo em seu HP.",
                necessaryLevel: 40,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 243,
                cast: 0,
                info:
                    "Durante 36 segundos retorna 90% do dano aplicado em inimigo em seu HP.",
                necessaryLevel: 44,
            },
            {
                level: 10,
                cooldown: 120,
                mp: 284,
                cast: 0,
                info:
                    "Durante 40 segundos retorna 100% do dano aplicado em inimigo em seu HP.",
                necessaryLevel: 48,
            },
        ],
    },
    {
        logoId: 7,
        name: "Travar Alvo",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 44,
                cast: 0,
                info:
                    "Causa 74 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 3 segundos.",
                necessaryLevel: 17,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 54,
                cast: 0,
                info:
                    "Causa 90 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 3 segundos.",
                necessaryLevel: 21,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 65,
                cast: 0,
                info:
                    "Causa 108 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 3 segundos.",
                necessaryLevel: 25,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 79,
                cast: 0,
                info:
                    "Causa 132 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 3 segundos.",
                necessaryLevel: 29,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 97,
                cast: 0,
                info:
                    "Causa 161 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 4 segundos.",
                necessaryLevel: 33,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 117,
                cast: 0,
                info:
                    "Causa 195 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 4 segundos.",
                necessaryLevel: 37,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 139,
                cast: 0,
                info:
                    "Causa 231 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 4 segundos.",
                necessaryLevel: 41,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 164,
                cast: 0,
                info:
                    "Causa 273 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 4 segundos.",
                necessaryLevel: 45,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 194,
                cast: 0,
                info:
                    "Causa 323 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 5 segundos.",
                necessaryLevel: 49,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 224,
                cast: 0,
                info:
                    "Causa 374 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 5 segundos.",
                necessaryLevel: 53,
            },
            {
                level: 11,
                cooldown: 6,
                mp: 260,
                cast: 0,
                info:
                    "Causa 434 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 5 segundos.",
                necessaryLevel: 57,
            },
            {
                level: 12,
                cooldown: 6,
                mp: 296,
                cast: 0,
                info:
                    "Causa 494 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 5 segundos.",
                necessaryLevel: 61,
            },
            {
                level: 13,
                cooldown: 6,
                mp: 334,
                cast: 0,
                info:
                    "Causa 557 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 6 segundos.",
                necessaryLevel: 65,
            },
            {
                level: 14,
                cooldown: 6,
                mp: 376,
                cast: 0,
                info:
                    "Causa 626 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 6 segundos.",
                necessaryLevel: 69,
            },
            {
                level: 15,
                cooldown: 6,
                mp: 422,
                cast: 0,
                info:
                    "Causa 704 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 6 segundos.",
                necessaryLevel: 73,
            },
            {
                level: 16,
                cooldown: 6,
                mp: 470,
                cast: 0,
                info:
                    "Causa 783 pontos de dano físico ao inimigo e obriga fixar o olhar em você durante 6 segundos.",
                necessaryLevel: 77,
            },
        ],
    },
    {
        logoId: 8,
        name: "Defesa Concentrada",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 80,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 30% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 19,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 97,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 33% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 23,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 116,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 36% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 27,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 139,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 39% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 31,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 167,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 42% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 35,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 200,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 45% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 39,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 234,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 48% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 43,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 273,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 51% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 47,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 316,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 54% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 51,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 362,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 57% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 55,
            },
            {
                level: 11,
                cooldown: 12,
                mp: 414,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 60% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 59,
            },
            {
                level: 12,
                cooldown: 12,
                mp: 461,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 63% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 63,
            },
            {
                level: 13,
                cooldown: 12,
                mp: 513,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 66% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 67,
            },
            {
                level: 14,
                cooldown: 12,
                mp: 571,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 69% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 71,
            },
            {
                level: 15,
                cooldown: 12,
                mp: 633,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 72% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 75,
            },
            {
                level: 16,
                cooldown: 12,
                mp: 696,
                cast: 0,
                info:
                    "Concentra os ataques inimigos no escudo reduzindo o dano recebido em 75% durante 12 segundos num máximo de 3 ataques.",
                necessaryLevel: 79,
            },
        ],
    },
    {
        logoId: 9,
        name: "Punição",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Adiciona 8 pontos da taxa de perigo em todos as ações realizadas.",
                necessaryLevel: 21,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Adiciona 16 pontos da taxa de perigo em todos as ações realizadas.",
                necessaryLevel: 25,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "GAdiciona 24 pontos da taxa de perigo em todos as ações realizadas.",
                necessaryLevel: 29,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Adiciona 32 pontos da taxa de perigo em todos as ações realizadas.",
                necessaryLevel: 33,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Adiciona 40 pontos da taxa de perigo em todos as ações realizadas.",
                necessaryLevel: 37,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Adiciona 48 pontos da taxa de perigo em todos as ações realizadas.",
                necessaryLevel: 41,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Adiciona 56 pontos da taxa de perigo em todos as ações realizadas.",
                necessaryLevel: 45,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Adiciona 64 pontos da taxa de perigo em todos as ações realizadas.",
                necessaryLevel: 49,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Adiciona 72 pontos da taxa de perigo em todos as ações realizadas.",
                necessaryLevel: 53,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Adiciona 80 pontos da taxa de perigo em todos as ações realizadas.",
                necessaryLevel: 57,
            },
        ],
    },
    {
        logoId: 10,
        name: "Revelação",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a cura em 120 e cura recebida em 3%, enquanto diminui o consumo de MP de habilidades de cura em 10%.",
                necessaryLevel: 23,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a cura em 240 e cura recebida em 4%, enquanto diminui o consumo de MP de habilidades de cura em 12%.",
                necessaryLevel: 27,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a cura em 360 e cura recebida em 4%, enquanto diminui o consumo de MP de habilidades de cura em 14%.",
                necessaryLevel: 31,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a cura em 480 e cura recebida em 5%, enquanto diminui o consumo de MP de habilidades de cura em 16%.",
                necessaryLevel: 35,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a cura em 600 e cura recebida em 5%, enquanto diminui o consumo de MP de habilidades de cura em 18%.",
                necessaryLevel: 39,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a cura em 720 e cura recebida em 6%, enquanto diminui o consumo de MP de habilidades de cura em 20%.",
                necessaryLevel: 43,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a cura em 840 e cura recebida em 6%, enquanto diminui o consumo de MP de habilidades de cura em 22%.",
                necessaryLevel: 47,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a cura em 960 e cura recebida em 7%, enquanto diminui o consumo de MP de habilidades de cura em 24%.",
                necessaryLevel: 51,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a cura em 1080 e cura recebida em 7%, enquanto diminui o consumo de MP de habilidades de cura em 26%.",
                necessaryLevel: 55,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a cura em 1200 e cura recebida em 8%, enquanto diminui o consumo de MP de habilidades de cura em 30%.",
                necessaryLevel: 59,
            },
        ],
    },
    {
        logoId: 11,
        name: "União Divina",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 112,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 30% do dano que ele receber para você, além de aumentar 16 de resistência a status anormais. União será quebrada após transferência de 2680 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 25,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 134,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 32% do dano que ele receber para você, além de aumentar 19 de resistência a status anormais. União será quebrada após transferência de 3216 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 29,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 161,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 34% do dano que ele receber para você, além de aumentar 22 de resistência a status anormais. União será quebrada após transferência de 3870 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 33,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 193,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 36% do dano que ele receber para você, além de aumentar 25 de resistência a status anormais. União será quebrada após transferência de 4638 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 37,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 228,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 38% do dano que ele receber para você, além de aumentar 28 de resistência a status anormais. União será quebrada após transferência de 5476 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 41,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 267,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 40% do dano que ele receber para você, além de aumentar 31 de resistência a status anormais. União será quebrada após transferência de 6400 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 45,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 311,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 42% do dano que ele receber para você, além de aumentar 34 de resistência a status anormais. União será quebrada após transferência de 7646 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 49,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 356,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 44% do dano que ele receber para você, além de aumentar 37 de resistência a status anormais. União será quebrada após transferência de 8554 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 53,
            },
            {
                level: 9,
                cooldown: 20,
                mp: 409,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 46% do dano que ele receber para você, além de aumentar 40 de resistência a status anormais. União será quebrada após transferência de 9802 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 57,
            },
            {
                level: 10,
                cooldown: 20,
                mp: 461,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 48% do dano que ele receber para você, além de aumentar 43 de resistência a status anormais. União será quebrada após transferência de 11058 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 61,
            },
            {
                level: 11,
                cooldown: 20,
                mp: 514,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 50% do dano que ele receber para você, além de aumentar 46 de resistência a status anormais. União será quebrada após transferência de 12322 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 65,
            },
            {
                level: 12,
                cooldown: 20,
                mp: 572,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 52% do dano que ele receber para você, além de aumentar 49 de resistência a status anormais. União será quebrada após transferência de 13720 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 69,
            },
            {
                level: 13,
                cooldown: 20,
                mp: 636,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 54% do dano que ele receber para você, além de aumentar 52 de resistência a status anormais. União será quebrada após transferência de 15258 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 73,
            },
            {
                level: 14,
                cooldown: 20,
                mp: 701,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 56% do dano que ele receber para você, além de aumentar 55 de resistência a status anormais. União será quebrada após transferência de 16818 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 77,
            },
            {
                level: 15,
                cooldown: 20,
                mp: 770,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 58% do dano que ele receber para você, além de aumentar 58 de resistência a status anormais. União será quebrada após transferência de 18476 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 81,
            },
            {
                level: 16,
                cooldown: 20,
                mp: 846,
                cast: 2,
                info:
                    "Se une a um aliado para transferir 60% do dano que ele receber para você, além de aumentar 60 de resistência a status anormais. União será quebrada após transferência de 20296 de dano ou ao afastar-se um do outro.",
                necessaryLevel: 85,
            },
        ],
    },
    {
        logoId: 12,
        name: "Proteção",
        levelsInfo: [
            {
                level: 1,
                cooldown: 180,
                mp: 175,
                cast: 2,
                info:
                    "Cria uma bolha protetora para bloquear as próximas 2 habilidades em um período de 5 minutos. Proteção reduzida para 1 ponto após transferência de canais.",
                necessaryLevel: 27,
            },
            {
                level: 2,
                cooldown: 180,
                mp: 209,
                cast: 2,
                info:
                    "Cria uma bolha protetora para bloquear as próximas 3 habilidades em um período de 5 minutos. Proteção reduzida para 1 ponto após transferência de canais.",
                necessaryLevel: 31,
            },
            {
                level: 3,
                cooldown: 180,
                mp: 251,
                cast: 2,
                info:
                    "Cria uma bolha protetora para bloquear as próximas 4 habilidades em um período de 5 minutos. Proteção reduzida para 1 ponto após transferência de canais.",
                necessaryLevel: 35,
            },
            {
                level: 4,
                cooldown: 180,
                mp: 300,
                cast: 2,
                info:
                    "Cria uma bolha protetora para bloquear as próximas 5 habilidades em um período de 5 minutos. Proteção reduzida para 1 ponto após transferência de canais.",
                necessaryLevel: 39,
            },
            {
                level: 5,
                cooldown: 180,
                mp: 351,
                cast: 2,
                info:
                    "Cria uma bolha protetora para bloquear as próximas 6 habilidades em um período de 5 minutos. Proteção reduzida para 1 ponto após transferência de canais.",
                necessaryLevel: 43,
            },
            {
                level: 6,
                cooldown: 180,
                mp: 410,
                cast: 2,
                info:
                    "Cria uma bolha protetora para bloquear as próximas 7 habilidades em um período de 5 minutos. Proteção reduzida para 1 ponto após transferência de canais.",
                necessaryLevel: 47,
            },
            {
                level: 7,
                cooldown: 180,
                mp: 474,
                cast: 2,
                info:
                    "Cria uma bolha protetora para bloquear as próximas 8 habilidades em um período de 5 minutos. Proteção reduzida para 1 ponto após transferência de canais.",
                necessaryLevel: 51,
            },
            {
                level: 8,
                cooldown: 180,
                mp: 542,
                cast: 2,
                info:
                    "Cria uma bolha protetora para bloquear as próximas 9 habilidades em um período de 5 minutos. Proteção reduzida para 1 ponto após transferência de canais.",
                necessaryLevel: 55,
            },
            {
                level: 9,
                cooldown: 180,
                mp: 621,
                cast: 2,
                info:
                    "Cria uma bolha protetora para bloquear as próximas 10 habilidades em um período de 5 minutos. Proteção reduzida para 1 ponto após transferência de canais.",
                necessaryLevel: 59,
            },
            {
                level: 10,
                cooldown: 180,
                mp: 692,
                cast: 2,
                info:
                    "Cria uma bolha protetora para bloquear as próximas 12 habilidades em um período de 5 minutos. Proteção reduzida para 1 ponto após transferência de canais.",
                necessaryLevel: 63,
            },
        ],
    },
    {
        logoId: 13,
        name: "Emissão Divina",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 199,
                cast: 0,
                info:
                    "Explosão que causa 306 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 32,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 240,
                cast: 0,
                info:
                    "Explosão que causa 369 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 36,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 290,
                cast: 0,
                info:
                    "Explosão que causa 447 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 40,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 341,
                cast: 0,
                info:
                    "Explosão que causa 525 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 44,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 404,
                cast: 0,
                info:
                    "Explosão que causa 621 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 48,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 468,
                cast: 0,
                info:
                    "Explosão que causa 720 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 52,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 542,
                cast: 0,
                info:
                    "Explosão que causa 834 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 56,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 620,
                cast: 0,
                info:
                    "Explosão que causa 954 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 60,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 702,
                cast: 0,
                info:
                    "Explosão que causa 1080 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 64,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 788,
                cast: 0,
                info:
                    "Explosão que causa 1212 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 68,
            },
            {
                level: 11,
                cooldown: 12,
                mp: 887,
                cast: 0,
                info:
                    "Explosão que causa 1365 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 72,
            },
            {
                level: 12,
                cooldown: 12,
                mp: 991,
                cast: 0,
                info:
                    "Explosão que causa 1524 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 76,
            },
            {
                level: 13,
                cooldown: 12,
                mp: 1102,
                cast: 0,
                info:
                    "Explosão que causa 1695 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 80,
            },
            {
                level: 14,
                cooldown: 12,
                mp: 1223,
                cast: 0,
                info:
                    "Explosão que causa 1881 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 84,
            },
            {
                level: 15,
                cooldown: 12,
                mp: 1359,
                cast: 0,
                info:
                    "Explosão que causa 2091 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 88,
            },
            {
                level: 16,
                cooldown: 12,
                mp: 1509,
                cast: 0,
                info:
                    "Explosão que causa 2322 de dano físico na área de 4M e  silencia por 3 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 92,
            },
        ],
    },
    {
        logoId: 14,
        name: "Escudo Refletor",
        levelsInfo: [
            {
                level: 1,
                cooldown: 40,
                mp: 240,
                cast: 0,
                info:
                    "Devolve ao atacante 50% do dano de todos os ataques durante 3 segundos.",
                necessaryLevel: 34,
            },
            {
                level: 2,
                cooldown: 40,
                mp: 291,
                cast: 0,
                info:
                    "Devolve ao atacante 55% do dano de todos os ataques durante 3 segundos.",
                necessaryLevel: 38,
            },
            {
                level: 3,
                cooldown: 40,
                mp: 347,
                cast: 0,
                info:
                    "Devolve ao atacante 60% do dano de todos os ataques durante 3 segundos.",
                necessaryLevel: 42,
            },
            {
                level: 4,
                cooldown: 40,
                mp: 408,
                cast: 0,
                info:
                    "Devolve ao atacante 65% do dano de todos os ataques durante 3 segundos.",
                necessaryLevel: 46,
            },
            {
                level: 5,
                cooldown: 40,
                mp: 480,
                cast: 0,
                info:
                    "Devolve ao atacante 70% do dano de todos os ataques durante 3 segundos.",
                necessaryLevel: 50,
            },
            {
                level: 6,
                cooldown: 40,
                mp: 555,
                cast: 0,
                info:
                    "Devolve ao atacante 75% do dano de todos os ataques durante 3 segundos.",
                necessaryLevel: 54,
            },
            {
                level: 7,
                cooldown: 40,
                mp: 644,
                cast: 0,
                info:
                    "Devolve ao atacante 80% do dano de todos os ataques durante 3 segundos.",
                necessaryLevel: 58,
            },
            {
                level: 8,
                cooldown: 40,
                mp: 729,
                cast: 0,
                info:
                    "Devolve ao atacante 85% do dano de todos os ataques durante 3 segundos.",
                necessaryLevel: 62,
            },
            {
                level: 9,
                cooldown: 40,
                mp: 819,
                cast: 0,
                info:
                    "Devolve ao atacante 90% do dano de todos os ataques durante 3 segundos.",
                necessaryLevel: 66,
            },
            {
                level: 10,
                cooldown: 40,
                mp: 920,
                cast: 0,
                info:
                    "Devolve ao atacante 95% do dano de todos os ataques durante 3 segundos.",
                necessaryLevel: 70,
            },
        ],
    },
    {
        logoId: 15,
        name: "El Tycia",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 0,
                cast: 0,
                info:
                    "Converte toda a MP amplificando em 150% para recuperar o HP do alvo, removendo todos os debuffs.",
                necessaryLevel: 36,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 0,
                cast: 0,
                info:
                    "Converte toda a MP amplificando em 160% para recuperar o HP do alvo, removendo todos os debuffs.",
                necessaryLevel: 40,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 0,
                cast: 0,
                info:
                    "Converte toda a MP amplificando em 170% para recuperar o HP do alvo, removendo todos os debuffs.",
                necessaryLevel: 44,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 0,
                cast: 0,
                info:
                    "Converte toda a MP amplificando em 180% para recuperar o HP do alvo, removendo todos os debuffs.",
                necessaryLevel: 48,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 0,
                cast: 0,
                info:
                    "Converte toda a MP amplificando em 190% para recuperar o HP do alvo, removendo todos os debuffs.",
                necessaryLevel: 52,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 0,
                cast: 0,
                info:
                    "Converte toda a MP amplificando em 200% para recuperar o HP do alvo, removendo todos os debuffs.",
                necessaryLevel: 56,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 0,
                cast: 0,
                info:
                    "Converte toda a MP amplificando em 210% para recuperar o HP do alvo, removendo todos os debuffs.",
                necessaryLevel: 60,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 0,
                cast: 0,
                info:
                    "Converte toda a MP amplificando em 220% para recuperar o HP do alvo, removendo todos os debuffs.",
                necessaryLevel: 64,
            },
            {
                level: 9,
                cooldown: 20,
                mp: 0,
                cast: 0,
                info:
                    "Converte toda a MP amplificando em 230% para recuperar o HP do alvo, removendo todos os debuffs.",
                necessaryLevel: 68,
            },
            {
                level: 10,
                cooldown: 20,
                mp: 0,
                cast: 0,
                info:
                    "Converte toda a MP amplificando em 250% para recuperar o HP do alvo, removendo todos os debuffs.",
                necessaryLevel: 72,
            },
        ],
    },
    {
        logoId: 16,
        name: "El Aster",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 286,
                cast: 1.5,
                info:
                    "Aumenta a resistência a status anormais em 37 pontos e a taxa de perigo em 50% durante 30 segundos.",
                necessaryLevel: 38,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 337,
                cast: 1.5,
                info:
                    "Aumenta a resistência a status anormais em 41 pontos e a taxa de perigo em 55% durante 30 segundos.",
                necessaryLevel: 42,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 394,
                cast: 1.5,
                info:
                    "Aumenta a resistência a status anormais em 45 pontos e a taxa de perigo em 60% durante 30 segundos.",
                necessaryLevel: 46,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 458,
                cast: 1.5,
                info:
                    "Aumenta a resistência a status anormais em 50 pontos e a taxa de perigo em 65% durante 30 segundos.",
                necessaryLevel: 50,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 524,
                cast: 1.5,
                info:
                    "Aumenta a resistência a status anormais em 56 pontos e a taxa de perigo em 70% durante 30 segundos.",
                necessaryLevel: 54,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 601,
                cast: 1.5,
                info:
                    "Aumenta a resistência a status anormais em 62 pontos e a taxa de perigo em 75% durante 30 segundos.",
                necessaryLevel: 58,
            },
            {
                level: 7,
                cooldown: 120,
                mp: 674,
                cast: 1.5,
                info:
                    "Aumenta a resistência a status anormais em 68 pontos e a taxa de perigo em 80% durante 30 segundos.",
                necessaryLevel: 62,
            },
            {
                level: 8,
                cooldown: 120,
                mp: 750,
                cast: 1.5,
                info:
                    "Aumenta a resistência a status anormais em 74 pontos e a taxa de perigo em 85% durante 30 segundos.",
                necessaryLevel: 66,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 833,
                cast: 1.5,
                info:
                    "Aumenta a resistência a status anormais em 81 pontos e a taxa de perigo em 90% durante 30 segundos.",
                necessaryLevel: 70,
            },
            {
                level: 10,
                cooldown: 120,
                mp: 927,
                cast: 1.5,
                info:
                    "O usuário se torna imune a status anormais e aumenta sua taxa de perigo em 100% durante 30 segundos.",
                necessaryLevel: 74,
            },
        ],
    },
    {
        logoId: 17,
        name: "El Thymos",
        levelsInfo: [
            {
                level: 1,
                cooldown: 180,
                mp: 521,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 68, velocidade de movimento 10 e taxa de duplo em 3 durante 40 segundos. Ataque normal causa dano em área equivalente a 60% do dano aplicado.",
                necessaryLevel: 40,
            },
            {
                level: 2,
                cooldown: 180,
                mp: 608,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 78, velocidade de movimento 10 e taxa de duplo em 3 durante 40 segundos. Ataque normal causa dano em área equivalente a 62% do dano aplicado.",
                necessaryLevel: 44,
            },
            {
                level: 3,
                cooldown: 180,
                mp: 710,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 90, velocidade de movimento 10 e taxa de duplo em 3 durante 40 segundos. Ataque normal causa dano em área equivalente a 64% do dano aplicado.",
                necessaryLevel: 48,
            },
            {
                level: 4,
                cooldown: 180,
                mp: 816,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 104, velocidade de movimento 10 e taxa de duplo em 4 durante 40 segundos. Ataque normal causa dano em área equivalente a 66% do dano aplicado.",
                necessaryLevel: 52,
            },
            {
                level: 5,
                cooldown: 180,
                mp: 935,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 118, velocidade de movimento 10 e taxa de duplo em 4 durante 40 segundos. Ataque normal causa dano em área equivalente a 68% do dano aplicado.",
                necessaryLevel: 56,
            },
            {
                level: 6,
                cooldown: 180,
                mp: 1064,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 134, velocidade de movimento 10 e taxa de duplo em 4 durante 40 segundos. Ataque normal causa dano em área equivalente a 70% do dano aplicado.",
                necessaryLevel: 60,
            },
            {
                level: 7,
                cooldown: 180,
                mp: 1184,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 150, velocidade de movimento 10 e taxa de duplo em 5 durante 40 segundos. Ataque normal causa dano em área equivalente a 72% do dano aplicado.",
                necessaryLevel: 64,
            },
            {
                level: 8,
                cooldown: 180,
                mp: 1317,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 166, velocidade de movimento 10 e taxa de duplo em 5 durante 40 segundos. Ataque normal causa dano em área equivalente a 74% do dano aplicado.",
                necessaryLevel: 68,
            },
            {
                level: 9,
                cooldown: 180,
                mp: 1466,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 186, velocidade de movimento 10 e taxa de duplo em 5 durante 40 segundos. Ataque normal causa dano em área equivalente a 76% do dano aplicado.",
                necessaryLevel: 72,
            },
            {
                level: 10,
                cooldown: 180,
                mp: 1621,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 208, velocidade de movimento 10 e taxa de duplo em 6 durante 40 segundos. Ataque normal causa dano em área equivalente a 78% do dano aplicado.",
                necessaryLevel: 76,
            },
            {
                level: 11,
                cooldown: 180,
                mp: 1781,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 232, velocidade de movimento 10 e taxa de duplo em 6 durante 40 segundos. Ataque normal causa dano em área equivalente a 80% do dano aplicado.",
                necessaryLevel: 80,
            },
            {
                level: 12,
                cooldown: 180,
                mp: 1957,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 258, velocidade de movimento 10 e taxa de duplo em 6 durante 40 segundos. Ataque normal causa dano em área equivalente a 82% do dano aplicado.",
                necessaryLevel: 84,
            },
            {
                level: 13,
                cooldown: 180,
                mp: 2149,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 292, velocidade de movimento 10 e taxa de duplo em 7 durante 40 segundos. Ataque normal causa dano em área equivalente a 84% do dano aplicado.",
                necessaryLevel: 88,
            },
            {
                level: 14,
                cooldown: 180,
                mp: 2361,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 334, velocidade de movimento 10 e taxa de duplo em 7 durante 40 segundos. Ataque normal causa dano em área equivalente a 86% do dano aplicado.",
                necessaryLevel: 92,
            },
            {
                level: 15,
                cooldown: 180,
                mp: 2593,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 380, velocidade de movimento 10 e taxa de duplo em 7 durante 40 segundos. Ataque normal causa dano em área equivalente a 88% do dano aplicado.",
                necessaryLevel: 96,
            },
            {
                level: 16,
                cooldown: 180,
                mp: 2781,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 456, velocidade de movimento 10 e taxa de duplo em 8 durante 40 segundos. Ataque normal causa dano em área equivalente a 90% do dano aplicado.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 18,
        name: "El Aegis",
        levelsInfo: [
            {
                level: 1,
                cooldown: 180,
                mp: 416,
                cast: 1,
                info:
                    "Aumenta a defesa física em 893, defesa mágica em 703 e regenera 73 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 40,
            },
            {
                level: 2,
                cooldown: 180,
                mp: 487,
                cast: 1,
                info:
                    "Aumenta a defesa física em 1054, defesa mágica em 830 e regenera 86 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 44,
            },
            {
                level: 3,
                cooldown: 180,
                mp: 568,
                cast: 1,
                info:
                    "Aumenta a defesa física em 1243, defesa mágica em 977 e regenera 100 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 48,
            },
            {
                level: 4,
                cooldown: 180,
                mp: 652,
                cast: 1,
                info:
                    "Aumenta a defesa física em 1483, defesa mágica em 1169 e regenera 115 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 52,
            },
            {
                level: 5,
                cooldown: 180,
                mp: 748,
                cast: 1,
                info:
                    "Aumenta a defesa física em 1735, defesa mágica em 1370 e regenera 132 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 56,
            },
            {
                level: 6,
                cooldown: 180,
                mp: 851,
                cast: 1,
                info:
                    "Aumenta a defesa física em 1997, defesa mágica em 1579 e regenera 149 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 60,
            },
            {
                level: 7,
                cooldown: 180,
                mp: 947,
                cast: 1,
                info:
                    "Aumenta a defesa física em 2269, defesa mágica em 1801 e regenera 167 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 64,
            },
            {
                level: 8,
                cooldown: 180,
                mp: 1053,
                cast: 1,
                info:
                    "Aumenta a defesa física em 2550, defesa mágica em 2030 e regenera 185 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 68,
            },
            {
                level: 9,
                cooldown: 180,
                mp: 1172,
                cast: 1,
                info:
                    "Aumenta a defesa física em 2869, defesa mágica em 2284 e regenera 206 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 72,
            },
            {
                level: 10,
                cooldown: 180,
                mp: 1296,
                cast: 1,
                info:
                    "Aumenta a defesa física em 3243, defesa mágica em 2583 e regenera 228 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 76,
            },
            {
                level: 11,
                cooldown: 180,
                mp: 1425,
                cast: 1,
                info:
                    "Aumenta a defesa física em 3656, defesa mágica em 2916 e regenera 251 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 80,
            },
            {
                level: 12,
                cooldown: 180,
                mp: 1565,
                cast: 1,
                info:
                    "Aumenta a defesa física em 4117, defesa mágica em 3285 e regenera 275 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 84,
            },
            {
                level: 13,
                cooldown: 180,
                mp: 1719,
                cast: 1,
                info:
                    "Aumenta a defesa física em 4604, defesa mágica em 3678 e regenera 301 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 88,
            },
            {
                level: 14,
                cooldown: 180,
                mp: 1889,
                cast: 1,
                info:
                    "Aumenta a defesa física em 5101, defesa mágica em 4097 e regenera 329 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 92,
            },
            {
                level: 15,
                cooldown: 180,
                mp: 2074,
                cast: 1,
                info:
                    "Aumenta a defesa física em 5694, defesa mágica em 4577 e regenera 358 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 96,
            },
            {
                level: 16,
                cooldown: 180,
                mp: 2224,
                cast: 1,
                info:
                    "Aumenta a defesa física em 6451, defesa mágica em 5216 e regenera 391 de HP a cada 2 segundos por 40 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 19,
        name: "Atração Divina",
        levelsInfo: [
            {
                level: 1,
                cooldown: 40,
                mp: 249,
                cast: 0,
                info:
                    "Puxa o inimigo dentro de 10M de distância, imobilizando-o por 3 segundos.",
                necessaryLevel: 51,
            },
            {
                level: 2,
                cooldown: 39,
                mp: 288,
                cast: 0,
                info:
                    "Puxa o inimigo dentro de 10M de distância, imobilizando-o por 4 segundos.",
                necessaryLevel: 55,
            },
            {
                level: 3,
                cooldown: 38,
                mp: 330,
                cast: 0,
                info:
                    "Puxa o inimigo dentro de 11M de distância, imobilizando-o por 5 segundos.",
                necessaryLevel: 59,
            },
            {
                level: 4,
                cooldown: 37,
                mp: 375,
                cast: 0,
                info:
                    "Puxa o inimigo dentro de 11M de distância, imobilizando-o por 6 segundos.",
                necessaryLevel: 63,
            },
            {
                level: 5,
                cooldown: 36,
                mp: 422,
                cast: 0,
                info:
                    "Puxa o inimigo dentro de 12M de distância, imobilizando-o por 7 segundos.",
                necessaryLevel: 67,
            },
            {
                level: 6,
                cooldown: 35,
                mp: 474,
                cast: 0,
                info:
                    "Puxa o inimigo dentro de 12M de distância, imobilizando-o por 8 segundos.",
                necessaryLevel: 71,
            },
            {
                level: 7,
                cooldown: 34,
                mp: 531,
                cast: 0,
                info:
                    "Puxa o inimigo dentro de 13M de distância, imobilizando-o por 9 segundos.",
                necessaryLevel: 75,
            },
            {
                level: 8,
                cooldown: 33,
                mp: 590,
                cast: 0,
                info:
                    "Puxa o inimigo dentro de 13M de distância, imobilizando-o por 10 segundos.",
                necessaryLevel: 79,
            },
            {
                level: 9,
                cooldown: 32,
                mp: 656,
                cast: 0,
                info:
                    "Puxa o inimigo dentro de 14M de distância, imobilizando-o por 11 segundos.",
                necessaryLevel: 83,
            },
            {
                level: 10,
                cooldown: 30,
                mp: 728,
                cast: 0,
                info:
                    "Puxa o inimigo dentro de 15M de distância, imobilizando-o por 12 segundos.",
                necessaryLevel: 87,
            },
        ],
    },
    {
        logoId: 20,
        name: "Defesa Automática",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Com a chance de 10% reduz todos os danos em 5%.",
                necessaryLevel: 55,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Com a chance de 12% reduz todos os danos em 6%.",
                necessaryLevel: 59,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Com a chance de 14% reduz todos os danos em 7%.",
                necessaryLevel: 63,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Com a chance de 16% reduz todos os danos em 8%.",
                necessaryLevel: 67,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Com a chance de 18% reduz todos os danos em 9%.",
                necessaryLevel: 71,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Com a chance de 20% reduz todos os danos em 10%.",
                necessaryLevel: 75,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Com a chance de 22% reduz todos os danos em 11%.",
                necessaryLevel: 79,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Com a chance de 24% reduz todos os danos em 12%.",
                necessaryLevel: 83,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Com a chance de 26% reduz todos os danos em 13%.",
                necessaryLevel: 87,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Com a chance de 30% reduz todos os danos em 15%.",
                necessaryLevel: 91,
            },
        ],
    },
    {
        logoId: 21,
        name: "Lâmina da Promessa",
        levelsInfo: [
            {
                level: 1,
                cooldown: 180,
                mp: 1242,
                cast: 0,
                info:
                    "Ataca inimigos numa área de 3M durante 20 segundos com dano de 70% do ataque físico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 59,
            },
            {
                level: 2,
                cooldown: 180,
                mp: 1384,
                cast: 0,
                info:
                    "Ataca inimigos numa área de 3M durante 21 segundos com dano de 73% do ataque físico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 63,
            },
            {
                level: 3,
                cooldown: 180,
                mp: 1540,
                cast: 0,
                info:
                    "Ataca inimigos numa área de 3M durante 22 segundos com dano de 76% do ataque físico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 67,
            },
            {
                level: 4,
                cooldown: 180,
                mp: 1713,
                cast: 0,
                info:
                    "Ataca inimigos numa área de 3M durante 23 segundos com dano de 79% do ataque físico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 71,
            },
            {
                level: 5,
                cooldown: 180,
                mp: 1900,
                cast: 0,
                info:
                    "Ataca inimigos numa área de 3M durante 24 segundos com dano de 82% do ataque físico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 75,
            },
            {
                level: 6,
                cooldown: 180,
                mp: 2087,
                cast: 0,
                info:
                    "Ataca inimigos numa área de 3M durante 25 segundos com dano de 85% do ataque físico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 79,
            },
            {
                level: 7,
                cooldown: 180,
                mp: 2294,
                cast: 0,
                info:
                    "Ataca inimigos numa área de 3M durante 26 segundos com dano de 88% do ataque físico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 83,
            },
            {
                level: 8,
                cooldown: 180,
                mp: 2520,
                cast: 0,
                info:
                    "Ataca inimigos numa área de 3M durante 27 segundos com dano de 91% do ataque físico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 87,
            },
            {
                level: 9,
                cooldown: 180,
                mp: 2767,
                cast: 0,
                info:
                    "Ataca inimigos numa área de 3M durante 28 segundos com dano de 94% do ataque físico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 91,
            },
            {
                level: 10,
                cooldown: 180,
                mp: 3038,
                cast: 0,
                info:
                    "Ataca inimigos numa área de 3M durante 29 segundos com dano de 97% do ataque físico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 95,
            },
            {
                level: 11,
                cooldown: 180,
                mp: 3337,
                cast: 0,
                info:
                    "Ataca inimigos numa área de 3M durante 30 segundos com dano de 100% do ataque físico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 22,
        name: "Santuário",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 855,
                cast: 0,
                info:
                    "Causa 1316 de dano numa área de 6M, tirando 1 feitiço e diminuindo a resistência a magia sagrada por 20 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 61,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 965,
                cast: 0,
                info:
                    "Causa 1484 de dano numa área de 6M, tirando 1 feitiço e diminuindo a resistência a magia sagrada por 22 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 65,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 1084,
                cast: 0,
                info:
                    "Causa 1668 de dano numa área de 6M, tirando 1 feitiço e diminuindo a resistência a magia sagrada por 24 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 69,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 1219,
                cast: 0,
                info:
                    "Causa 1876 de dano numa área de 6M, tirando 1 feitiço e diminuindo a resistência a magia sagrada por 26 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 73,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 1357,
                cast: 0,
                info:
                    "Causa 2088 de dano numa área de 6M, tirando 1 feitiço e diminuindo a resistência a magia sagrada por 28 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 77,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 1508,
                cast: 0,
                info:
                    "Causa 2320 de dano numa área de 6M, tirando 1 feitiço e diminuindo a resistência a magia sagrada por 30 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 81,
            },
            {
                level: 7,
                cooldown: 120,
                mp: 1674,
                cast: 0,
                info:
                    "Causa 2576 de dano numa área de 6M, tirando 1 feitiço e diminuindo a resistência a magia sagrada por 32 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 85,
            },
            {
                level: 8,
                cooldown: 120,
                mp: 1862,
                cast: 0,
                info:
                    "Causa 2864 de dano numa área de 6M, tirando 1 feitiço e diminuindo a resistência a magia sagrada por 34 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 89,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 2067,
                cast: 0,
                info:
                    "Causa 3180 de dano numa área de 6M, tirando 1 feitiço e diminuindo a resistência a magia sagrada por 36 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 93,
            },
            {
                level: 10,
                cooldown: 120,
                mp: 2296,
                cast: 0,
                info:
                    "Causa 3532 de dano numa área de 6M, tirando 1 feitiço e diminuindo a resistência a magia sagrada por 38 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 97,
            },
            {
                level: 11,
                cooldown: 120,
                mp: 2421,
                cast: 0,
                info:
                    "Causa 3724 de dano numa área de 6M, tirando 1 feitiço e diminuindo a resistência a magia sagrada por 40 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 23,
        name: "Julgamento",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 12 pontos e o crítico em 1 ponto.",
                necessaryLevel: 65,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 16 pontos e o crítico em 2 pontos.",
                necessaryLevel: 69,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 20 pontos e o crítico em 3 pontos.",
                necessaryLevel: 73,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 24 pontos e o crítico em 4 pontos.",
                necessaryLevel: 77,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 28 pontos e o crítico em 5 pontos.",
                necessaryLevel: 81,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 32 pontos e o crítico em 6 pontos.",
                necessaryLevel: 85,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 36 pontos e o crítico em 7 pontos.",
                necessaryLevel: 89,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 40 pontos e o crítico em 8 pontos.",
                necessaryLevel: 93,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 44 pontos e o crítico em 9 pontos.",
                necessaryLevel: 97,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o ataque físico em 48 pontos e o crítico em 10 pontos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 24,
        name: "Fé Imortal",
        levelsInfo: [
            {
                level: 1,
                cooldown: 300,
                mp: 1083,
                cast: 0,
                info:
                    "Aumenta o seu HP máximo em 2515 pontos e recupera o HP no mesmo valor do HP máximo aumentado durante 60 segundos.",
                necessaryLevel: 69,
            },
            {
                level: 2,
                cooldown: 300,
                mp: 1204,
                cast: 0,
                info:
                    "Aumenta o seu HP máximo em 2797 pontos e recupera o HP no mesmo valor do HP máximo aumentado durante 60 segundos.",
                necessaryLevel: 73,
            },
            {
                level: 3,
                cooldown: 300,
                mp: 1328,
                cast: 0,
                info:
                    "Aumenta o seu HP máximo em 3083 pontos e recupera o HP no mesmo valor do HP máximo aumentado durante 60 segundos.",
                necessaryLevel: 77,
            },
            {
                level: 4,
                cooldown: 300,
                mp: 1458,
                cast: 0,
                info:
                    "Aumenta o seu HP máximo em 3387 pontos e recupera o HP no mesmo valor do HP máximo aumentado durante 60 segundos.",
                necessaryLevel: 81,
            },
            {
                level: 5,
                cooldown: 300,
                mp: 1602,
                cast: 0,
                info:
                    "Aumenta o seu HP máximo em 3721 pontos e recupera o HP no mesmo valor do HP máximo aumentado durante 60 segundos.",
                necessaryLevel: 85,
            },
            {
                level: 6,
                cooldown: 300,
                mp: 1760,
                cast: 0,
                info:
                    "Aumenta o seu HP máximo em 4087 pontos e recupera o HP no mesmo valor do HP máximo aumentado durante 60 segundos.",
                necessaryLevel: 89,
            },
            {
                level: 7,
                cooldown: 300,
                mp: 1933,
                cast: 0,
                info:
                    "Aumenta o seu HP máximo em 4488 pontos e recupera o HP no mesmo valor do HP máximo aumentado durante 60 segundos.",
                necessaryLevel: 93,
            },
            {
                level: 8,
                cooldown: 300,
                mp: 2123,
                cast: 0,
                info:
                    "Aumenta o seu HP máximo em 4929 pontos e recupera o HP no mesmo valor do HP máximo aumentado durante 60 segundos.",
                necessaryLevel: 97,
            },
            {
                level: 9,
                cooldown: 300,
                mp: 2224,
                cast: 0,
                info:
                    "Aumenta o seu HP máximo em 5166 pontos e recupera o HP no mesmo valor do HP máximo aumentado durante 60 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 25,
        name: "Cruz do Julgamento",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 862,
                cast: 0,
                info:
                    "Cria uma cruz sagrada e a lança em direção aos seus inimigos causando 1326 de dano físico em todos os inimigos no caminho.",
                necessaryLevel: 71,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 965,
                cast: 0,
                info:
                    "Cria uma cruz sagrada e a lança em direção aos seus inimigos causando 1485 de dano físico em todos os inimigos no caminho.",
                necessaryLevel: 75,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 1073,
                cast: 0,
                info:
                    "Cria uma cruz sagrada e a lança em direção aos seus inimigos causando 1650 de dano físico em todos os inimigos no caminho.",
                necessaryLevel: 79,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 1191,
                cast: 0,
                info:
                    "Cria uma cruz sagrada e a lança em direção aos seus inimigos causando 1833 de dano físico em todos os inimigos no caminho.",
                necessaryLevel: 83,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 1324,
                cast: 0,
                info:
                    "Cria uma cruz sagrada e a lança em direção aos seus inimigos causando 2037 de dano físico em todos os inimigos no caminho.",
                necessaryLevel: 87,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 1470,
                cast: 0,
                info:
                    "Cria uma cruz sagrada e a lança em direção aos seus inimigos causando 2262 de dano físico em todos os inimigos no caminho.",
                necessaryLevel: 91,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 1632,
                cast: 0,
                info:
                    "Cria uma cruz sagrada e a lança em direção aos seus inimigos causando 2511 de dano físico em todos os inimigos no caminho.",
                necessaryLevel: 95,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 1815,
                cast: 0,
                info:
                    "Cria uma cruz sagrada e a lança em direção aos seus inimigos causando 2793 de dano físico em todos os inimigos no caminho.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 26,
        name: "Carinho do Céu",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 950,
                cast: 2,
                info:
                    "Aumenta 30 pontos de Constituição, Sorte, e todos os efeitos de cura em 6% durante 60 minutos.",
                necessaryLevel: 75,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 1043,
                cast: 2,
                info:
                    "Aumenta 33 pontos de Constituição, Sorte, e todos os efeitos de cura em 7% durante 60 minutos.",
                necessaryLevel: 79,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 1147,
                cast: 2,
                info:
                    "Aumenta 36 pontos de Constituição, Sorte, e todos os efeitos de cura em 8% durante 60 minutos.",
                necessaryLevel: 83,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 1260,
                cast: 2,
                info:
                    "Aumenta 39 pontos de Constituição, Sorte, e todos os efeitos de cura em 9% durante 60 minutos.",
                necessaryLevel: 87,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 1384,
                cast: 2,
                info:
                    "Aumenta 42 pontos de Constituição, Sorte, e todos os efeitos de cura em 10% durante 60 minutos.",
                necessaryLevel: 91,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 1519,
                cast: 2,
                info:
                    "Aumenta 45 pontos de Constituição, Sorte, e todos os efeitos de cura em 11% durante 60 minutos.",
                necessaryLevel: 95,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 1668,
                cast: 2,
                info:
                    "Aumenta 48 pontos de Constituição, Sorte, e todos os efeitos de cura em 12% durante 60 minutos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 27,
        name: "Carga Divina",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 715,
                cast: 0,
                info:
                    "Debuffa o alvo a uma distância 9M e causa 1100 de dano físico, diminuindo o ataque físico e mágico do alvo em 25% por 6 segundos.",
                necessaryLevel: 79,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 794,
                cast: 0,
                info:
                    "Debuffa o alvo a uma distância 9M e causa 1222 de dano físico, diminuindo o ataque físico e mágico do alvo em 28% por 6 segundos.",
                necessaryLevel: 83,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 883,
                cast: 0,
                info:
                    "Debuffa o alvo a uma distância 9M e causa 1358 de dano físico, diminuindo o ataque físico e mágico do alvo em 31% por 6 segundos.",
                necessaryLevel: 87,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 980,
                cast: 0,
                info:
                    "Debuffa o alvo a uma distância 9M e causa 1508 de dano físico, diminuindo o ataque físico e mágico do alvo em 34% por 6 segundos.",
                necessaryLevel: 91,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 1088,
                cast: 0,
                info:
                    "Debuffa o alvo a uma distância 9M e causa 1674 de dano físico, diminuindo o ataque físico e mágico do alvo em 37% por 6 segundos.",
                necessaryLevel: 95,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 1210,
                cast: 0,
                info:
                    "Debuffa o alvo a uma distância 9M e causa 1862 de dano físico, diminuindo o ataque físico e mágico do alvo em 40% por 6 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 28,
        name: "Escudo Celestial",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 1458,
                cast: 3,
                info:
                    "Aumenta a defesa física em 1281 e a defesa mágica em 1028. A habilidade possui uma chance de 10% de reduzir o dano recebido em 15%.",
                necessaryLevel: 81,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 1602,
                cast: 3,
                info:
                    "Aumenta a defesa física em 1423 e a defesa mágica em 1142. A habilidade possui uma chance de 12% de reduzir o dano recebido em 18%.",
                necessaryLevel: 85,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 1760,
                cast: 3,
                info:
                    "Aumenta a defesa física em 1580 e a defesa mágica em 1268. A habilidade possui uma chance de 14% de reduzir o dano recebido em 21%.",
                necessaryLevel: 89,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 1933,
                cast: 3,
                info:
                    "Aumenta a defesa física em 1784 e a defesa mágica em 1432. A habilidade possui uma chance de 16% de reduzir o dano recebido em 24%.",
                necessaryLevel: 93,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 2123,
                cast: 3,
                info:
                    "Aumenta a defesa física em 2042 e a defesa mágica em 1650. A habilidade possui uma chance de 18% de reduzir o dano recebido em 27%.",
                necessaryLevel: 97,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 2224,
                cast: 3,
                info:
                    "Aumenta a defesa física em 2152 e a defesa mágica em 1739. A habilidade possui uma chance de 20% de reduzir o dano recebido em 30%.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 29,
        name: "Forja de Aço",
        levelsInfo: [
            {
                level: 1,
                cooldown: 180,
                mp: 2403,
                cast: 0,
                info:
                    "Aumenta a defesa física e mágica sua e do grupo em 50% e também a resistência a crítico e duplo em 5 por 12 segundos.",
                necessaryLevel: 85,
            },
            {
                level: 2,
                cooldown: 180,
                mp: 2640,
                cast: 0,
                info:
                    "Aumenta a defesa física e mágica sua e do grupo em 55% e também a resistência a crítico e duplo em 8 por 14 segundos.",
                necessaryLevel: 89,
            },
            {
                level: 3,
                cooldown: 180,
                mp: 2899,
                cast: 0,
                info:
                    "Aumenta a defesa física e mágica sua e do grupo em 60% e também a resistência a crítico e duplo em 10 por 16 segundos.",
                necessaryLevel: 93,
            },
            {
                level: 4,
                cooldown: 180,
                mp: 3184,
                cast: 0,
                info:
                    "Aumenta a defesa física e mágica sua e do grupo em 65% e também a resistência a crítico e duplo em 12 por 18 segundos.",
                necessaryLevel: 97,
            },
            {
                level: 5,
                cooldown: 180,
                mp: 3337,
                cast: 0,
                info:
                    "Aumenta a defesa física e mágica sua e do grupo em 70% e também a resistência a crítico e duplo em 15 por 20 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 30,
        name: "Salvador Imprudente",
        levelsInfo: [
            {
                level: 1,
                cooldown: 50,
                mp: 2046,
                cast: 0,
                info:
                    "Entra em batalha com um escudo que absorve 20460 de dano físico nos membros do grupo por 15 segundos e coloca um buff de proteção rápida ao usuário que neutraliza o recebimento de 5 habilidades se a  habilidade Proteção não estiver ativa.",
                necessaryLevel: 89,
            },
            {
                level: 2,
                cooldown: 50,
                mp: 2272,
                cast: 0,
                info:
                    "Entra em batalha com um escudo que absorve 22720 de dano físico nos membros do grupo por 15 segundos e coloca um buff de proteção rápida ao usuário que neutraliza o recebimento de 5 habilidades se a  habilidade Proteção não estiver ativa.",
                necessaryLevel: 93,
            },
            {
                level: 3,
                cooldown: 50,
                mp: 2524,
                cast: 0,
                info:
                    "Entra em batalha com um escudo que absorve 25240 de dano físico nos membros do grupo por 15 segundos e coloca um buff de proteção rápida ao usuário que neutraliza o recebimento de 5 habilidades se a  habilidade Proteção não estiver ativa.",
                necessaryLevel: 97,
            },
            {
                level: 4,
                cooldown: 50,
                mp: 2660,
                info:
                    "Entra em batalha com um escudo que absorve 26600 de dano físico nos membros do grupo por 15 segundos e coloca um buff de proteção rápida ao usuário que neutraliza o recebimento de 5 habilidades se a  habilidade Proteção não estiver ativa.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 31,
        name: "Escudo Vingador",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 2857,
                cast: 0,
                info:
                    "Inflige 2930 de dano físico aos inimigos dentro de um raio de 5M e os torna vulneráveis a ataques sagrados por um minuto. O usuário reflete todos os danos por 5 segundos.",
                necessaryLevel: 95,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 3178,
                cast: 0,
                info:
                    "Inflige 3259 de dano físico aos inimigos dentro de um raio de 5M e os torna vulneráveis a ataques sagrados por um minuto. O usuário reflete todos os danos por 5 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
]
